module.exports = __webpack_public_path__ + "img/banklogo-3.c4d49c6f.png";